import React, {Component, createRef} from 'react';
import * as ReactDOM from "react-dom";
import autobind from 'autobind-decorator';


export const ReactTableScrollbarEnhance = ((ComposedComponent) => class ReactTableScrollbarEnhance extends Component {
    constructor(props) {
        super(props);

        this.dataTableElement = createRef();
    }

    @autobind
    componentDidMount() {
        this.theads = ReactDOM.findDOMNode(this.dataTableElement.current).getElementsByClassName("rt-thead");
        this.tbody = ReactDOM.findDOMNode(this.dataTableElement.current).getElementsByClassName("rt-tbody")[0];

        this.tbody.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        this.tbody.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.applyHeaderChanges();
    }

    @autobind
    handleScroll() {
        for (let i = 0; i < this.theads.length; i++) {
            this.theads.item(i).scrollLeft = this.tbody.scrollLeft;
        }
    }

    @autobind
    applyHeaderChanges() {
        if (this.tbody.scrollHeight > this.tbody.clientHeight) {
            for (let i = 0; i < this.theads.length; i++) {
                this.theads.item(i).classList.add("vertical-scrollbar-present");
            }
        }
        else {
            for (let i = 0; i < this.theads.length; i++) {
                this.theads.item(i).classList.remove("vertical-scrollbar-present");
            }
        }
    }

    @autobind
    render() {
        return <ComposedComponent
            ref={this.dataTableElement}
            {...this.props}
        />;
    }
});
